/* eslint-disable @angular-eslint/use-lifecycle-interface */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/quotes */
import { MediaMatcher } from "@angular/cdk/layout";
import { ChangeDetectorRef, Component, OnInit, OnDestroy } from "@angular/core";
@Component({
  selector: "app-audit-trail",
  templateUrl: "./audit-trail.component.html",
  styleUrls: ["./audit-trail.component.scss"],
})
export class AuditTrailComponent implements OnInit {
  visible = false;
  userDetails = [];
  auditTrailLogs = [];
  viewPreuploadImages(a: any, b: any, c: any) {}
  constructor(changeDetectorRef: ChangeDetectorRef, media: MediaMatcher) {
    this.mobileQuery = media.matchMedia("(max-width: 600px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }
  ngOnInit() {}

  mobileQuery: MediaQueryList;

  fillerNav: any[] = [
    {
      label: "Registration",
      routerLink: "/secure/audit-trail",
    },
    {
      label: "Application",
      routerLink: "/secure/audit-trail/application",
    },
    {
      label: "Payment",
      routerLink: "/secure/audit-trail/payment",
    },
    // {
    //   label: "Profile Details",
    //   routerLink: "/secure/audit-trail/profileDetails",
    // },
    {
      label: "Chatbot",
      routerLink: "/secure/audit-trail/user-chats",
    },
  ];

  private _mobileQueryListener: () => void;

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
}
